export const getLiveDevKey = ({ test_key, live_key }) => {
  if (process.env.NODE_ENV === 'development') {
    return test_key
  } else {
    return live_key
  }
}
